import { useEffect, useState } from "react"

type UseScrollStateOptions = {
  threshold?: number
}

export function useScrollState(options: UseScrollStateOptions = {}) {
  const { threshold = 20 } = options
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    let frame = 0

    const update = () => {
      setIsScrolled(window.scrollY > threshold)
      frame = 0
    }

    const onScroll = () => {
      if (frame) {
        return
      }

      frame = window.requestAnimationFrame(update)
    }

    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })

    return () => {
      window.removeEventListener("scroll", onScroll)
      if (frame) {
        window.cancelAnimationFrame(frame)
      }
    }
  }, [threshold])

  return { isScrolled }
}
